import React, { useEffect, useState } from "react";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import classnames from "classnames";
import {
  Button,
  Card,
  CardHeader,
  Modal,
  ModalBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import TabOrganizationOverview from "../Settings/SettingOrgInfoSupporter/components/TabOrganizationOverview";
import TabOrganizationMission from "../Settings/SettingOrgInfoSupporter/components/TabOrganizationMission";
import TabPublishedInformation from "../Settings/SettingOrgInfoSupporter/components/TabPublishedInformation";
import { useMutation, useQuery } from "@apollo/client";
import { GET_SUPPORTER_PROFILE } from "../../queries";
import { useParams } from "react-router-dom";

const SupporterProfile = () => {
  const { supporterId } = useParams();
  const [orgActiveTab, setOrgActiveTab] = useState("1");
  const [modalUploadIcon, setModalUploadIcon] = useState(false);
  const [logo, setLogo] = useState();

  const supporterInfo = useQuery(GET_SUPPORTER_PROFILE, {
    variables: { supporterId: supporterId },
  });

  function handleChangeTab(tab) {
    if (orgActiveTab !== tab) setOrgActiveTab(tab);
  }

  useEffect(() => {
    const tab = localStorage?.getItem("tab");
    if (tab) {
      setOrgActiveTab(tab);
      localStorage.removeItem("tab");
    } else return;
  }, []);

  return (
    <CSSTransitionGroup
      component="div"
      transitionName="TabsAnimation"
      transitionAppear={true}
      transitionAppearTimeout={0}
      transitionEnter={false}
      transitionLeave={false}
    >
      <Card className="mb-3">
        <CardHeader className="org_title">
          {supporterInfo?.data?.getSpecificSupporter?.logoUrl ? (
            <img
              src={supporterInfo?.data?.getSpecificSupporter?.logoUrl}
              alt=""
              className="profile-blur opacity-9"
              style={{ width: "40px", cursor: "pointer" }}
              onClick={() => setModalUploadIcon(true)}
            />
          ) : (
            <div></div>
          )}
          <h4 className="org_name">
            {supporterInfo?.data?.getSpecificSupporter?.name}
          </h4>
        </CardHeader>
      </Card>

      <Card className="mb-2 original-card__sp">
        <CardHeader className="card-header-tab">
          <Nav>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "1" })}
                onClick={() => {
                  handleChangeTab("1");
                }}
              >
                組織概要
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "2" })}
                onClick={() => {
                  handleChangeTab("2");
                }}
              >
                ミッションと連携方針
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: orgActiveTab === "3" })}
                onClick={() => {
                  handleChangeTab("3");
                }}
              >
                情報開示と第三者認証
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
      </Card>

      <TabContent activeTab={orgActiveTab} className="card-tab">
        <TabPane tabId="1">
          <TabOrganizationOverview
            publicView={true}
            passedOrgSupporterRaw={supporterInfo}
          />
        </TabPane>
        <TabPane tabId="2">
          <TabOrganizationMission publicView={true} />
        </TabPane>
        <TabPane tabId="3">
          <TabPublishedInformation publicView={true} />
        </TabPane>
      </TabContent>
    </CSSTransitionGroup>
  );
};

export default SupporterProfile;
